import React from 'react';







const WeekName =()=>{

    return(
        <div className="d-flex align-items-center ">



            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>شنبه</div>
            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>یکشنبه</div>
            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>دوشنبه</div>
            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>سه شنبه</div>
            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>چهارشنبه</div>
            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>پنجشنبه</div>
            <div style={{width:'100%',fontFamily:'iransans',fontSize:10,textAlign:'center',padding:2,fontWeight:'bold',color:'#152e84'}}>جمعه</div>



        </div>

    );

}


export default WeekName ;
